/* eslint-disable react/prop-types */
import React from 'react';
import {
  createStackNavigator,
  CardStyleInterpolators,
} from '@react-navigation/stack';
import { useSafeAreaInsets } from 'react-native-safe-area-context';

import { isWeb, isMobileWeb } from '@global/screens';
import { setTitleHeader, setDefaultStackOption } from '@global/helpers';

import HamburgerButton from '@components/navbar/HamburgerButton';
import NotificationSettingButton from '@components/navbar/NotificationSettingButton';
import BackButton from '@components/navbar/BackButton';

import PricelistScreen from '@/screens/setting/pricelist/PricelistScreen';
import PricelistDetailScreen from '@/screens/setting/pricelist/PricelistDetailScreen';

const Stack = createStackNavigator();

// eslint-disable-next-line react/prop-types
const LoyaltyPointNavigator = ({ navigation }) => {
  const insets = useSafeAreaInsets();
  return (
    <Stack.Navigator
      initialRouteName="PricelistScreen"
      screenOptions={(props) => ({
        headerLeft: () => <HamburgerButton {...props} />,
        headerRight: () => <NotificationSettingButton {...props} />,
        ...setDefaultStackOption(insets, CardStyleInterpolators),
      })}>
      <Stack.Screen
        name="PricelistScreen"
        component={PricelistScreen}
        options={(props) => {
          return {
            title: setTitleHeader('Pricelist'),
            hideScroll: true,
          };
        }}
      />
      <Stack.Screen
        name="PricelistDetailScreen"
        component={PricelistDetailScreen}
        options={(props) => {
          return {
            title: 'Add Pricelist',
            // navigate() to the list (not pop) so back survives a browser
            // refresh, where the list isn't in the fresh stack.
            headerLeft: () => (
              <BackButton
                {...props}
                onPress={() => props.navigation.navigate('PricelistScreen')}
              />
            ),
          };
        }}
      />
      <Stack.Screen
        name="PricelistEditScreen"
        component={PricelistDetailScreen}
        options={(props) => {
          const route = props.route;
          let title = 'Detail Pricelist';
          if (route.params && route.params.name && !(isWeb && !isMobileWeb)) {
            title = route.params.name;
          }
          return {
            title: setTitleHeader(title),
            headerLeft: () => (
              <BackButton
                {...props}
                // navigate() (pop) not replace() — preserves the migrated list
                // instance (scroll + filter via openChild) on return.
                isJump={true}
                customBack={{ screen: 'PricelistScreen' }}
              />
            ),
          };
        }}
      />
    </Stack.Navigator>
  );
};

export default LoyaltyPointNavigator;
